var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 0.499878H12C14.7614 0.499878 17 2.73845 17 5.49988V12.0624L8.25 12.0624C7.73223 12.0624 7.3125 12.4821 7.3125 12.9999C7.3125 13.5176 7.73223 13.9374 8.25 13.9374L17 13.9374V20.4999C17 23.2613 14.7614 25.4999 12 25.4999H5.75C2.98858 25.4999 0.75 23.2613 0.75 20.4999V17.9999V7.99988V5.49988C0.75 2.73845 2.98858 0.499878 5.75 0.499878ZM17 13.9374L22.2367 13.9374L20.0871 16.087C19.721 16.4531 19.721 17.0467 20.0871 17.4128C20.4532 17.7789 21.0468 17.7789 21.4129 17.4128L24.279 14.5467C25.1333 13.6924 25.1333 12.3074 24.279 11.4531L21.4129 8.58697C21.0468 8.22085 20.4532 8.22085 20.0871 8.58697C19.721 8.95308 19.721 9.54667 20.0871 9.91279L22.2367 12.0624L17 12.0624V13.9374Z",
    fill: "#B877FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutactive);
export default __webpack_public_path__ + "static/media/Logoutactive.1d32528b2a51800ffa45a211fcf97e2e.svg";
export { ForwardRef as ReactComponent };